import { Link } from "react-router-dom";

const programs = [
  {
    tag: "INSTRUCTOR PATH",
    title: "BLS Instructor Classes",
    description: "Ready to teach? Our BLS Instructor course qualifies you to certify others. Perfect for healthcare educators and clinical leads.",
    image: "https://public.readdy.ai/ai/img_res/243eb85a59703a881acc18b0de016211.jpg",
    forWhom: "Healthcare educators & professionals",
  },
  {
    tag: "ADVANCED CARE",
    title: "ACLS & PALS",
    description: "Advanced Cardiovascular and Pediatric Life Support for providers who need next-level emergency response skills.",
    image: "https://static.readdy.ai/image/99ee4fd5eb46fc3e1cae300823aab6a6/a584342858df976fe8bd33c85e127d02.webp",
    forWhom: "Physicians, nurses & paramedics",
  },
  {
    tag: "ESSENTIAL SKILLS",
    title: "First Aid / CPR / AED",
    description: "The fundamentals of emergency response. Ideal for workplaces, schools, fitness centers, and everyday heroes.",
    image: "https://readdy.ai/api/search-image?query=diverse%20group%20of%20people%20learning%20CPR%20first%20aid%20training%20session%20hands%20on%20practice%20modern%20bright%20training%20room%20community%20class%20professional%20photography&width=400&height=350&seq=8&orientation=landscape",
    forWhom: "General public & workplaces",
  },
  {
    tag: "GROUP SESSIONS",
    title: "Corporate & Group Training",
    description: "Tailored on-site training for teams of any size. We bring the expertise directly to your organization.",
    image: "https://readdy.ai/api/search-image?query=corporate%20team%20medical%20training%20session%20group%20of%20employees%20learning%20CPR%20AED%20office%20training%20room%20professional%20instructor%20high%20quality%20photography&width=400&height=350&seq=9&orientation=landscape",
    forWhom: "Businesses & organizations",
  },
];

export default function LearnWithUs() {
  return (
    <section className="py-24 bg-brand-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block border border-brand-gold/50 text-brand-gold text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-full mb-4">
            Learn With Us
          </span>
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-white mb-4">
            Training for Every Level,{" "}
            <span className="text-brand-gold">Every Goal</span>
          </h2>
          <div className="w-20 h-1 bg-brand-gold mx-auto mb-4" />
          <p className="text-gray-400 max-w-2xl mx-auto text-lg">
            Whether you&apos;re a beginner or a seasoned healthcare professional,
            Cardiocraft CPR has a course designed for your journey.
          </p>
        </div>

        {/* Cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
          {programs.map((prog) => (
            <div
              key={prog.title}
              className="bg-white/5 border border-white/10 rounded-xl overflow-hidden hover:border-brand-gold/40 transition-all duration-300 group"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={prog.image}
                  alt={prog.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <span className="text-xs font-bold text-brand-gold uppercase tracking-wider">{prog.tag}</span>
                <h3 className="font-serif font-bold text-white text-lg mt-2 mb-3">{prog.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed mb-4">{prog.description}</p>
                <p className="text-gray-500 text-xs mb-4">
                  <i className="ri-user-line mr-1" />
                  {prog.forWhom}
                </p>
                <Link
                  to="/booking#reserve-spot"
                  className="inline-flex items-center gap-1 text-brand-gold text-sm font-semibold hover:gap-2 transition-all cursor-pointer"
                >
                  Enroll Now <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/courses"
            className="inline-flex items-center gap-2 bg-brand-gold text-brand-black font-bold px-8 py-3.5 rounded-md hover:bg-brand-gold-dark transition-colors cursor-pointer whitespace-nowrap"
          >
            View All Programs
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
